<template>
  <div class="container">
    <div class="content">{{content}}</div>
  </div>
</template>
<script>
export default {
  name:'maildetail',
  data() {
    return{
      content:'',
    }
  },
  created(){
    if(!this.$route.query.id){
      this.$router.push('/mail');
      return;
    }
    this.$axios({
      method:'post',
      url:'/api/home/zhannei_info',
      data:this.qs.stringify({
        token:sessionStorage.getItem('wmtoken'),
        id:this.$route.query.id,
      })
    }).then(res => {
      console.log(res.data);
      if(res.data.code == 0){
        this.content = res.data.data.content;
      }
    })
  },
}
</script>
<style scoped>
.content{
  padding: 10px;
  line-height: 2em;
  text-indent: 2em;
}
</style>


// WEBPACK FOOTER //
// src/components/maildetail.vue